import comp from "./AssignmentCommonSettings";
export default comp;
